const mContentEditor = {
  mContentEditor: {
    alerts: {
      updateContenidoNodo: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El contenido fue guardado exitosamente.'
      }
    },

    buttonPrimary: 'GUARDAR'
  }
}

export default mContentEditor
